import { z } from 'zod';
import { CAPABILITIES } from '../rbac.js';
/**
 * What an operator posts to create or edit a `TenantRole` (custom staff roles, D77).
 * `builtInKey` is never accepted here — it is set only by the backfill and the seed, never
 * by a request, because it is what decides which role cannot be deleted and what a reset
 * restores.
 */
export const roleWriteSchema = z.object({
    name: z.string().trim().min(1).max(60),
    description: z.string().trim().max(200).optional().or(z.literal('')),
    capabilities: z.array(z.enum(CAPABILITIES)).min(1),
});
//# sourceMappingURL=role.js.map